import { createSlice } from "@reduxjs/toolkit";
import {
  setWithdrawalPin,
  getWithdrawalPin,
  withdraw,
} from "./WithdrawActions";

const initialState = {
  loading: false,
  error: null,
  withdrawal_address: "",
  success: false, // for monitoring the registration process.
};

const withdrawalSlice = createSlice({
  name: "withdrawal",
  initialState,
  reducers: {},
  extraReducers: {
    [setWithdrawalPin.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.success = true;
    },
    [setWithdrawalPin.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [setWithdrawalPin.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [getWithdrawalPin.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.success = true;
    },
    [getWithdrawalPin.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getWithdrawalPin.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [withdraw.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.success = true;
    },
    [withdraw.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [withdraw.rejected]: (state, { payload }) => {
      state.loading = false;
    },
  },
});

export default withdrawalSlice.reducer;
